import React from 'react'
import {
    Box,
    Typography,
} from '@material-ui/core'
import axios from 'axios'
import { withStyles } from '@material-ui/styles'
import { cloneDeep } from 'lodash'
import * as moment from 'moment'
import { get } from 'lodash'

// Components
import Dialog from '../../components/Dialog'
import EmployeesTable from './EmployeesTable'
import MissingTitlesList from './MissingTitlesList'
import UploadEmployees from './UploadEmployees'
import Actions from './Actions'
import JobTitleSelectionStep1 from './JobTitleSelectionStep1'
import JobTitleSelectionStep2 from './JobTitleSelectionStep2'
import JobTitleSelectionStep3 from './JobTitleSelectionStep3'
import DeleteAllEmployeesConfirmation from './DeleteAllEmployeesConfirmation'
import CustomizedSnackbars from '../../components/MessageSnacks/CustomizedSnackbars'

// styles
import { styles } from './styles'
import { currency, handleCurrency } from '../../helpers'

class Employees extends React.Component {

    state = {
        employeesData: {},
        missingTitlesDlgOpen: false,
        uploadEmployeesDlgOpen: false,
        isJobTitlesMissing: false,
        openJobTitleSelectionStep1: false,
        openJobTitleSelectionStep2: false,
        openJobTitleSelectionStep3: false,
        missingTitlesDataVersion: 0,
        openDeleteAllEmployeesDlg: false,
        openErrorMessage: false,
        errorMessage: '',
        incorrectEntry: false,
        incorrectJobCatLevel: false,
    }

    selectedJobTitle = null
    jobGroups = null
    masterData = null
    questionAnswers = null
    selecableLevels = []
    currencyColumnNames = ['annual_base_salary', 'target_incentive_amnt', 'target_total_cash', 'salary_p50', 'salary_p75', 
    'comp_ttc_p50', 'comp_ttc_p75', 'total_stock_options_granted_value', 'current_vested_equity_value',
    'current_unvested_equity_value', 'stock_options_p50', 'stock_options_p75', 'rsu_granted_value',
    'rsu_vested_value', 'rsu_unvested_value', 'comp_unvested_stock_options_plus_rsu']

    classes = this.props.classes

    setEmployeesData = () => {
        axios(`/api/employees?perPage=2000&page=1`)
            .then((result) => {
                let rowCounter = 1
                const employeesData = result.data.data
                let incorrectEntry = false
                let incorrectJobCatLevel = false
                employeesData.data = employeesData.data.map(dataObj => { return { ...dataObj, rowCounter: rowCounter++ } })
                if (employeesData.data) {
                    employeesData.data.forEach(row => {
                        if (!incorrectEntry && isNaN(row.performance_rating)) {
                            incorrectEntry = true
                        }
                        if(!incorrectJobCatLevel && ((row.compkit_job_category === null || row.compkit_job_level === null) || ((row.compkit_job_category === '' || row.compkit_job_level === '')))){
                            incorrectJobCatLevel = true
                        }
                        this.currencyColumnNames.forEach(columnName => {
                             row[columnName] = currency(row[columnName], row.compensation_local_currency)
                         })
                    })
                }

                this.setState({
                    employeesData: employeesData,
                    isJobTitlesMissing: result.data.isMissingFields,
                    incorrectEntry: incorrectEntry,
                    incorrectJobCatLevel: incorrectJobCatLevel
                })
                axios.get('/api/company/update_company_currencies')
            })
            .catch((error) => {
                this.setState({ employees: { total: 0, perPage: 0, page: 0, lastPage: 0, data: [] } })
            })
	}
	showErrorMessages = (res, table) => {
		const errorMessageArray = get(res, 'data.errors', []).map(currentValue => {
			return currentValue.message.replace(currentValue.field, table.find(({ field }) => field === currentValue.field).title)
		})
		if(errorMessageArray.length) {
			this.setState({
				openErrorMessage: true,
				errorMessage: errorMessageArray.join('\n')
			})
		}
	}


    createEmployee = async (employeeData, table) => {
        const payload = cloneDeep(employeeData)
        payload['employee_hire_date'] = (payload['employee_hire_date']) ? moment(payload['employee_hire_date']).format('YYYY-MM-DD') : null
        payload['date_of_last_base_salary_change'] = (payload['date_of_last_base_salary_change']) ? moment(payload['date_of_last_base_salary_change']).format('YYYY-MM-DD') : null
        
        this.currencyColumnNames.forEach(columnName => {
            payload[`${columnName}`] = handleCurrency(payload[`${columnName}`])
        })
        try {
            let res = await axios.post(`/api/employees/`, payload)
            if (res.data.status) {
                this.setEmployeesData()
                this.props.dataChanged()
                return res.data.status
            } else {
				this.showErrorMessages(res, table)
                return res.data.status
            }
        } catch (e) {
            this.setState({
                openErrorMessage: true,
                errorMessage: get(e, 'message', 'Error Occured while creating employee')
            })
            return false;
        }
    }

    updateEmployee = async (employeeData, table) => {
        const payload = cloneDeep(employeeData)
        this.currencyColumnNames.forEach(columnName => {
            payload[columnName] = handleCurrency(payload[columnName])
        })
        payload['employee_hire_date'] = (payload['employee_hire_date']) ? moment(payload['employee_hire_date']).format('YYYY-MM-DD') : null
        payload['date_of_last_base_salary_change'] = (payload['date_of_last_base_salary_change']) ? moment(payload['date_of_last_base_salary_change']).format('YYYY-MM-DD') : null
        delete payload.radfordJobCode
        try {
            let res = await axios.put(`/api/employees/${employeeData.id}`, payload)
            if (res.data.status) {
                axios.get('/api/company/update_company_currencies')
                this.setEmployeesData()
                this.props.dataChanged()
                return res.data.status
            } else {
				this.showErrorMessages(res, table)
                return res.data.status
            }
        } catch (e) {
            this.setState({
                openErrorMessage: true,
                errorMessage: get(e, 'message', 'Error Occured while updating employee')
            })
            return false;
        }
    }

    deleteEmployee = async (employee) => {
        try {
            await axios.delete(`/api/employees/${employee.id}`)
            await axios.get('/api/company/update_company_currencies')
            this.props.dataChanged()
            this.setEmployeesData()
        } catch (e) {
            this.setEmployeesData()
        }
    }

    componentDidMount() {
        document.title = `CompKit - Employees`;
        let user = JSON.parse(localStorage.getItem('user'))
        if(user.roles.includes('finance') || user.roles.includes('client_group')){
            this.props.history.push('/app/reports')
        }else{
            this.setEmployeesData()
            this.masterData = this.processMasterData(this.props.masterData)
        }
    }

    processMasterData = (rawMasterData) => {
        const jobLevels = {}
        for (const jobType of rawMasterData.jobGrades) {
            const obj = {
                level: parseInt(jobType.job_grade.slice(1)),
                title: jobType.job_title,
                description: jobType.job_description,
            }
            if (!jobLevels[jobType.job_abbr]) {
                jobLevels[jobType.job_abbr] = []
            }
            jobLevels[jobType.job_abbr].push(obj)
        }

        const masterData = {
            jobFunctions: rawMasterData.jobFuncs.map(jobFunction => jobFunction.job_function),
            jobSubFunctions: rawMasterData.jobSubFuncs.map(jobSubFunction => jobSubFunction.job_subfunction),
            jobLevels: jobLevels,
        }

        return masterData
    }

    handleMissingTitleSelection = (title) => {
        this.selectedJobTitle = title
        this.setState({ openJobTitleSelectionStep1: true })
    }

    handleEmployeesUpload = () => {
        this.setEmployeesData()
        this.setState({ uploadEmployeesDlgOpen: false })
    }

    handleTemplateDownload = async () => {
        const response = await axios.get('/api/employee/download_sample_employee_file')
        window.open(response.data.data, "_blank")
    }

    handleEmployeesDownload = async () => {
        const response = await axios.get('/api/employee/download_employees')
        window.open(response.data.data, "_blank")
    }

    handleCompKitTitleSelection = (compKitTitle) => {
        const payload = {
            company_job_title: this.selectedJobTitle.companyJobTitle,
            job_id: compKitTitle.id
        }
        axios.post('/api/job_decision', payload).then(res => {
            if (res.data.status === 'success') {
                this.postDecisionRendering(1)
            } else {
                this.postDecisionRendering(1)
            }
        })
    }

    handleQuestionsFilling = (answers) => {
        this.questionAnswers = answers
        axios.post('/api/job_groups', answers).then(res => {
            if (res.data.status === true) {
                this.jobGroups = res.data.data
                if (this.jobGroups) {
                    this.setState({
                        openJobTitleSelectionStep1: false,
                        openJobTitleSelectionStep2: true,
                    })
                }
            } else {
                this.selectedJobTitle = null
                this.setState({
                    openJobTitleSelectionStep1: false,
                    missingTitlesDlgOpen: true,
                })
            }
        })
    }

    handleJobGroupSelection = (selection) => {
        const selectableLevels = this.jobGroups[selection.selectedFunctionIndex].jobs[selection.selectedGroupIndex].levels
        if (selectableLevels.length === 1) {
            // no need for step#3
            this.handleLevelSelection(selectableLevels[0], 2)
            return
        }

        // master levels of selected category
        try {
            const masterLevels = this.masterData.jobLevels[this.questionAnswers.job_category]
            const selectableLevelsWithDetails = []
            for (const selectableLevel of selectableLevels) {
                for (const masterLevel of masterLevels) {
                    if (masterLevel.level === selectableLevel.job_level) {
                        selectableLevelsWithDetails.push({
                            level: selectableLevel.job_level,
                            id: selectableLevel.id,
                            title: masterLevel.title,
                            description: masterLevel.description,
                            code: `${this.questionAnswers.job_category}${selectableLevel.job_level}`,
                        })
                    }
                }
            }

            this.selecableLevels = selectableLevelsWithDetails
            this.setState(prevState => {
                return {
                    openJobTitleSelectionStep3: true,
                    openJobTitleSelectionStep2: false,
                    openJobTitleSelectionStep1: false
                }
            })

        } catch (error) {
            console.log(error)
        }
    }

    postDecisionRendering = (stepNumber) => {
        this.selectedJobTitle = null
        this.setState({
            [`openJobTitleSelectionStep${stepNumber}`]: false,
            missingTitlesDlgOpen: true,
            missingTitlesDataVersion: this.state.missingTitlesDataVersion + 1
        })
    }

    handleLevelSelection = (level, stepNumber = 3) => {
        const payload = {
            company_job_title: this.selectedJobTitle.companyJobTitle,
            job_id: level.id
        }
        axios.post('/api/job_decision', payload).then(res => {
            if (res.data.status === 'success') {
                this.postDecisionRendering(stepNumber)
            } else {
                this.postDecisionRendering(stepNumber)
            }
        })
    }

    handleEmployeeDeleteAll = () => {
        this.setState({ openDeleteAllEmployeesDlg: true })
    }

    deleteAllEmployees = () => {
        axios.delete('/api/employees/all').then(res => {
            if (res.data.status) {
                axios.get('/api/company/update_company_currencies')
                this.setState({ openDeleteAllEmployeesDlg: false })
                this.setEmployeesData()
            } else {
                this.setState({ openDeleteAllEmployeesDlg: false })
                // show error popup
            }
        })
    }

    handleActionSelection = (action) => {
        switch (action) {
            case 'downloadEmployees':
                this.handleEmployeesDownload()
                break;
            case 'uploadEmployees':
                this.setState({ uploadEmployeesDlgOpen: true })
                break;
            case 'donwloadTemplate':
                this.handleTemplateDownload()
                break;
            case 'deleteAllEmployees':
                this.handleEmployeeDeleteAll()
                break;
            default:
                break;
        }
    }

    handleClose = () => {
        this.setState({ openErrorMessage: false })
    }

    showErrorMessage = (message) => {
        this.setState({ openErrorMessage: true, errorMessage: message })
    }

    render() {
        return (
            <>
                <CustomizedSnackbars
                    open={this.state.openErrorMessage}
                    handleClose={this.handleClose}
                    variant={'error'}
                    message={this.state.errorMessage}
                />
                <Box m={2} display="flex" flexDirection="row-reverse">
                    <Actions
                        onActionSelected={this.handleActionSelection}
                    />
                    {/* {this.state.isJobTitlesMissing && (
                        <Button
                            variant="contained"
                            color="default"
                            className={clsx(this.classes.button, this.classes.warningButton)}
                            onClick={() => this.setState({ missingTitlesDlgOpen: true })}
                        >
                            Standardization of Data Elements Required
                        </Button>
                    )} */}
                </Box>
                {this.state.incorrectEntry ?
                    (
                        <Box m={2} display="flex" justifyContent="left">
                            <Typography align='center'
                                color='error'
                                variant='body2'
                            >
                                Performance rating column has incorrect values.
							</Typography>
                        </Box>
                    )
                    :
                    null
                }
                {this.state.incorrectJobCatLevel ?
                    (
                        <Box m={2} display="flex" justifyContent="left">
                            <Typography align='center'
                                color='error'
                                variant='body2'
                            >
                                Job Category or Job Level columns have some empty entries
							</Typography>
                        </Box>
                    )
                    :
                    null
                }


                <EmployeesTable
                    employeesData={this.state.employeesData}
                    updateEmployee={this.updateEmployee}
                    deleteEmployee={this.deleteEmployee}
                    createEmployee={this.createEmployee}
                />

                <Dialog
                    size={'sm'}
                    title={'Missing Job Titles'}
                    isOpen={this.state.missingTitlesDlgOpen}
                    onClose={() => this.setState({ missingTitlesDlgOpen: false })}
                >
                    <MissingTitlesList
                        onTitleSelection={this.handleMissingTitleSelection}
                        dataVersion={this.state.missingTitlesDataVersion}
                        showErrorMessage={this.showErrorMessage}
                    />
                </Dialog>

                <Dialog
                    size={'sm'}
                    title={'Upload Employees Data'}
                    isOpen={this.state.uploadEmployeesDlgOpen}
                    onClose={() => this.setState({ uploadEmployeesDlgOpen: false })}
                >
                    <UploadEmployees
                        onEmployeesUpload={this.handleEmployeesUpload}
                        onDownloadTemplate={this.handleTemplateDownload}
                    />
                </Dialog>

                <DeleteAllEmployeesConfirmation
                    open={this.state.openDeleteAllEmployeesDlg}
                    onClose={() => this.setState({ openDeleteAllEmployeesDlg: false })}
                    onDeleteAllClicked={this.deleteAllEmployees}
                />

                <>
                    <Dialog
                        size={'sm'}
                        title={`Job Title Matching (${this.selectedJobTitle ? this.selectedJobTitle.companyJobTitle : ''})`}
                        isOpen={!!(this.state.openJobTitleSelectionStep1 && this.selectedJobTitle && this.masterData)}
                        onClose={() => this.setState({ openJobTitleSelectionStep1: false })}
                    >
                        <JobTitleSelectionStep1
                            onCompKitTitleSelection={this.handleCompKitTitleSelection}
                            onQuestionsFilling={this.handleQuestionsFilling}
                            masterData={this.masterData ? this.masterData : {jobFunctions:[]}}
                        />
                    </Dialog>
                    <Dialog
                        size={'md'}
                        title={'Choose Job Group'}
                        isOpen={(this.state.openJobTitleSelectionStep2 && this.jobGroups && this.selectedJobTitle && this.masterData)}
                        onClose={() => this.setState({ openJobTitleSelectionStep2: false })}
                    >
                        <JobTitleSelectionStep2
                            onGroupSelection={this.handleJobGroupSelection}
                            groups={this.jobGroups ? this.jobGroups : []}
                        />
                    </Dialog>

                    <Dialog
                        size={'md'}
                        title={'Choose Job Group'}
                        isOpen={(this.state.openJobTitleSelectionStep3 && this.selecableLevels.length && this.selectedJobTitle && this.masterData)}
                        onClose={() => this.setState({ openJobTitleSelectionStep3: false })}
                    >
                        <JobTitleSelectionStep3
                            onLevelSelection={this.handleLevelSelection}
                            levels={this.selecableLevels}
                        />
                    </Dialog>
                </>
            </>
        )
    }
}

export default withStyles(styles)(Employees)
